import { Branch } from 'src/app/models/branch';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductsService } from '../../../services/products.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from 'src/app/models/product';
import { BranchesService } from 'src/app/services/branches.service';
import { StockAmount } from 'src/app/models/stock-amount';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'product-details',
  templateUrl: './product-details-modal.component.html',
  styleUrls: ['./product-details-modal.component.sass'],
})
export class ProductDetailsModalComponent {
  public product: Product = new Product();
  public modal: boolean = false;


  constructor(
    private bsModalRef: BsModalRef,
  ) {
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
